// @flow
import axios from 'lib/defaultClient';
import qs from 'query-string';

export type SearchParams = {
  q: string,
  username?: string,
  page?: number,
  menu: string,
  facets?: string,
  sort?: string,
};

export const search = ({ q, username, page, menu, facets, sort }: SearchParams) => {
  const query = qs.stringify({ q, username, page, menu, facets, sort });
  return axios.get(`/search?${query}`);
};

export const autoComplete = ({ q, username, page, menu }: SearchParams) => {
  const query = qs.stringify({ q, username, page, menu });
  return axios.get(`/search/auto-complete?${query}`);
};

export const getSimilarProducts = (productId: string, limit: number = 10) => {
  const query = qs.stringify({ id: productId, limit });
  return axios.get(`/search/similar?${query}`);
};



// WEBPACK FOOTER //
// ./src/lib/api/search.js